import page from './index';

export default {
    path: '/home/tiger/plan-history',
    meta: { titie: '计划委托历史' },
    component: page
}
